module.exports = __webpack_public_path__ + "media/images/transparent-5c7622f66f08e0e56301114536108a75.gif";